import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type UpdateUserAppSettingMutationVariables = Types.Exact<{
  input: Types.UpdateUserAppSettingInput;
}>;


export type UpdateUserAppSettingMutation = { __typename?: 'Mutation', updateUserAppSetting: { __typename?: 'UserAppSettingPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, setting?: { __typename?: 'UserAppSettingData', appSettingsId: string, base64Settings: string, created: Types.TDateISO, emailAddress: string, group: string, name: string, tenantId: string } | null } };

export type GetUserAppSettingsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.UserAppSettingDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.UserAppSettingDocumentSortInput> | Types.UserAppSettingDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetUserAppSettingsQuery = { __typename?: 'Query', userAppSettings?: { __typename?: 'UserAppSettingsConnection', totalCount: number, nodes?: Array<{ __typename?: 'UserAppSettingDocument', appSettingsId: string, base64Settings: string, created: Types.TDateISO, emailAddress: string, group: string, name: string, tenantId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const UpdateUserAppSettingDocument = new TypedDocumentString(`
    mutation UpdateUserAppSetting($input: UpdateUserAppSettingInput!) {
  updateUserAppSetting(input: $input) {
    errors {
      code
      message
    }
    setting {
      appSettingsId
      base64Settings
      created
      emailAddress
      group
      name
      tenantId
    }
  }
}
    `);
export const GetUserAppSettingsDocument = new TypedDocumentString(`
    query GetUserAppSettings($where: UserAppSettingDocumentFilterInput, $order: [UserAppSettingDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  userAppSettings(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      appSettingsId
      base64Settings
      created
      emailAddress
      group
      name
      tenantId
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    UpdateUserAppSetting: build.mutation<UpdateUserAppSettingMutation, UpdateUserAppSettingMutationVariables>({
      query: (variables) => ({ document: UpdateUserAppSettingDocument, variables })
    }),
    GetUserAppSettings: build.query<GetUserAppSettingsQuery, GetUserAppSettingsQueryVariables | void>({
      query: (variables) => ({ document: GetUserAppSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useUpdateUserAppSettingMutation, useGetUserAppSettingsQuery, useLazyGetUserAppSettingsQuery } = injectedRtkApi;
